import { useContext } from 'react';
import { ClipBoard } from 'components/common/ClipBoard/ClipBoard';
import { CurrencyIcon } from 'components/common/CurrencyIcon/CurrencyIcon';
import i18nContext from 'components/i18n-context';
import { getAccountNumber, getAccountTitle } from 'components/utils';
import { CRYPTO_CURRENCY_PRECISION, CURRENCIES, isStableCoin } from 'services/currenciesConstant';
import { amountFormattedValue, formatAccountNumber } from 'services/utils';
import { ActionButton } from 'uikit/ActionButton/ActionButton';
import { CURRENCY_SYMBOLS } from 'components/common/constants';
import './Card.scss';

export const Card = ({
  type,
  isCardAccount,
  isManualAccount,
  isCryptoAccount,
  account,
  balance,
  currency,
  networkCode,
  reserved,
  onExclaimPointClick,
  onTransactionClick,
  onPaymentClick,
  mobileText,
  tooltipText = []
}) => {
  const i18n = useContext(i18nContext);
  const accountTitle = getAccountTitle(account);
  const accountNumber = getAccountNumber(account);

  if (type === 'list') {
    return (
      <div className={'account-card-row list'}>
        <div className={'account-card-item'}>
          <p className={'card-mobile-text'}>{mobileText?.account}</p>
          <p className={'account'}>{account}</p>
        </div>
        <div className={'account-card-item'}>
          <p className={'card-mobile-text'}>{mobileText?.currency}</p>
          <p className={'currency'}>{currency}</p>
        </div>
        <div className={'account-card-item'}>
          <p className={'card-mobile-text'}>{mobileText?.reserved}</p>
          <p className={'reserved'}>
            {amountFormattedValue(reserved, isCryptoAccount ? CRYPTO_CURRENCY_PRECISION : 2) + ' ' + currency}
          </p>
        </div>
        <div className={'account-card-item'}>
          <p className={'card-mobile-text'}>{mobileText?.balance}</p>
          <p className={'balance'}>
            {amountFormattedValue(balance, isCryptoAccount ? CRYPTO_CURRENCY_PRECISION : 2) + ' ' + currency}
          </p>
        </div>
        <div className={'account-card-item'}>
          <p className={'card-mobile-text'}>{mobileText?.actions}</p>
          <div className={'wrapper-icon'}>
            <ActionButton tooltipText={tooltipText && tooltipText[2]} onClick={onExclaimPointClick} />
            <ActionButton
              tooltipText={tooltipText && tooltipText[0]}
              iconType={'transaction'}
              onClick={onTransactionClick}
            />
            <ActionButton
              tooltipText={tooltipText && tooltipText[1]}
              iconType={'new-payment'}
              onClick={onPaymentClick}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={'account-card accounts-page'}>
      <div className={'left-side'}>
        <div className={'currency-wrapper'}>
          <CurrencyIcon
            isCardAccount={isCardAccount}
            currencyIcon={
              isCryptoAccount && isStableCoin(currency)
                ? CURRENCIES[currency]?.networks?.[networkCode]?.icon || null
                : CURRENCIES[currency]?.icon || CURRENCIES.OTHERS?.icon || null
            }
          />
          <p className={`${isCryptoAccount ? 'crypto-currency-code' : 'currency-code'}`}>{currency}</p>
          {isCryptoAccount && isStableCoin(currency) && networkCode && <p className={'currency-code'}>{networkCode}</p>}
        </div>
        <div className={'balance-info available'}>
          <p className={'balance-label'}>{i18n.getMessage('accounts.card.available')}:</p>
          <p className={'balance-value'}>
            {isCryptoAccount
              ? `${amountFormattedValue(balance, CRYPTO_CURRENCY_PRECISION)} ${currency}`
              : `${CURRENCY_SYMBOLS[currency] || '$'}${amountFormattedValue(balance, 2)}`}
          </p>
        </div>
        <div className={'balance-info pending'}>
          <p className={'balance-label'}>{i18n.getMessage('accounts.card.pending')}:</p>
          <p className={'balance-label'}>
            {isCryptoAccount
              ? `${amountFormattedValue(reserved, CRYPTO_CURRENCY_PRECISION)} ${currency}`
              : `${CURRENCY_SYMBOLS[currency] || '$'}${amountFormattedValue(reserved, 2)}`}
          </p>
        </div>
        <div className={'account-wrapper'}>
          <ClipBoard
            isCardComponent={true}
            copyText={isCardAccount || isManualAccount ? accountNumber : accountTitle}
          />
          <p className={'account-number'}>
            {isCardAccount || isManualAccount ? accountTitle : formatAccountNumber(accountTitle)}
          </p>
        </div>
      </div>
      <div className={'account-action-buttons-wrapper'}>
        <ActionButton
          isCardIcon={true}
          tooltipText={tooltipText[1]}
          iconType={'new-payment'}
          onClick={onPaymentClick}
        />
        <ActionButton isCardIcon={true} tooltipText={tooltipText[2]} iconType={'info'} onClick={onExclaimPointClick} />
        <ActionButton
          isCardIcon={true}
          tooltipText={tooltipText[0]}
          iconType={'transaction'}
          onClick={onTransactionClick}
        />
      </div>
    </div>
  );
};

Card.propTypes = {};
